import { Component, OnInit } from '@angular/core';

@Component({
    templateUrl: 'application.component.html',
  standalone: false
})

export class ApplicationComponent implements OnInit {
    constructor() { }

    ngOnInit() { }
}